//it meant to be "add global tag" but it ended to be "add tag" and the name stuck with us
//or edit
(function () {

    "use strict";

    var dependencies = ['$q', 'tagsDataService', 'ColorsHelper', 'hUser', 'userPermissions'];

    function AddGlobalTagForm(formName) {
        var self = this;

        self.isLoading = true;
        self.isEdit = false;
        self.tag = {};
        self.smartFields = [];
        var tagsDataService = dependencies.tagsDataService;
        var ColorsHelper = dependencies.ColorsHelper;
        var $q = dependencies.$q;
        const userPermissions = dependencies.userPermissions;
        self.isTopLevelContext = dependencies.hUser.isTopLevelContext();
        self.recruitmentHubSpeedy = tagsDataService.RECRUITMENT_HUB_SPEEDY;

        self.loadData = function (modalData) {
            self.tag = angular.copy(modalData.tag);
            self.isLoading = false;
            self.isEdit = !!(self.tag && self.tag.id);
            self.type = modalData?.type || '';

            if (!self.isEdit) {
                self.tag = self.tag || {};
                if (!self.tag.color_hash) {
                    self.tag.color_hash = ColorsHelper.getRandomColor();
                }
            }
        };

        self.setBrandId = async (_brandId) => {
            self.brandId = _brandId;
            const policyParser = await userPermissions.getBrandPolicy(self.brandId);
            self.canManagePrivateTags = policyParser.has(userPermissions.PERMISSIONS.MANAGE_PRIVATE_TAGS);
        };

        var saveFallbackHandler = function (res) {
            var errors = res.data.errors;
            for (var i in errors) {
                var err = errors[i];
                if (err.code === 'NAME_ALREADY_EXIST') {
                    self.errors.name = {
                        msg: 'Tag name already exists for this brand, please use unique name'
                    };
                } else if (err.code === 'COLOR_ALREADY_EXIST') {
                    self.errors.color = {
                        msg: 'Tag color already exists for this brand, please use unique color'
                    };
                }
            }
            console.error(err);
        };

        self.save = function () {
            var defer = $q.defer();

            var tag = {
                "name": self.tag.name,
                "color_hash": self.tag.color_hash,
                "is_private": self.tag.is_private,
                "mode": self.tag.mode,
            };

            self.isLoading = true;
            self.errors = {};
            if (self.tag && self.tag.id) {
                tag.id = self.tag.id;
                tag.tagged_candidate_id = self.tag.tagged_candidate_id;
                tagsDataService.updateTag(self.brandId, tag)
                    .then(function (res) {
                        defer.resolve(res);
                    })
                    .catch(function (err) {
                        saveFallbackHandler(err);
                        defer.reject(err);
                    })
                    .finally(function () {
                        self.isLoading = false;
                    });
            } else {
                tagsDataService.createTag(self.brandId, tag)
                    .then(function (res) {
                        defer.resolve(res);
                    })
                    .catch(function (err) {
                        saveFallbackHandler(err);
                        defer.reject(err);
                    })
                    .finally(function () {
                        self.isLoading = false;
                    });
            }

            return defer.promise;
        };

        self.isPrivateChanged = function () {
            self.validator.validate(function () {});
        };

        self.deleteTag = function () {
            var defer = $q.defer();
            if (self.tag && self.tag.id) {
                self.isLoading = true;
                tagsDataService.askToDeleteTag(self.brandId, self.tag)
                    .then(function (res) {
                        defer.resolve(res);
                    })
                    .catch(function (err) {
                        defer.reject(err);
                    })
                    .finally(function () {
                        self.isLoading = false;
                    });
            } else {
                defer.reject();
            }
            return defer.promise;
        };

        self.destroy = function () {
            self.tag = {};
            self.isLoading = false;
        };

        self.validator.validateCustom = function(field, optionsField, rule, showError, callback) {
            var name = field.attr("name");

            switch (rule.name) {
                case "nameExistAsLocalTag":

                    if (!self.tag.is_private && self.isTopLevelContext && self.type !== self.recruitmentHubSpeedy) {
                        var tag = {
                            name: self.tag.name
                        };
                        self.checking = true;
                        tagsDataService.isNameExists(self.brandId, tag)
                            .then(function (res) {
                                callback(!res.exists);
                                return;
                            })
                            .catch(function (err) {
                                console.error(err);
                                callback(false);
                                return;
                            })
                            .finally(function () {
                                self.checking = false;
                            });
                    } else {
                        callback(true);
                        return;
                    }

                    break;
            }
            return true;
        };

    }

    angular
        .module("harriApp")
        .run(['hFormsService', function (hFormsService) {

            hFormsService.registerForm("AddGlobalTagForm", {
                form: AddGlobalTagForm,
                dependencies: dependencies
            });
        }]);
})();
